import { TdsGlobalFooter, TdsGlobalFooterLinks } from '@trv-tds/react'

const Footer = () => {
  return (
    <TdsGlobalFooter sociallinks='true' role='contentinfo'>
      <TdsGlobalFooterLinks slot='links' heading='Products &amp; Services'>
        <a href='https://www.travelers.com/individuals'>For Individuals</a>
        <a href='https://www.travelers.com/business-insurance'>For Businesses</a>
        <a href='https://www.travelers.com/claims'>Claim Services</a>
        <a href='https://www.travelers.com/resources'>Prepare &amp; Prevent</a>
      </TdsGlobalFooterLinks>
      <TdsGlobalFooterLinks slot='links' heading='Our Company'>
        <a href='https://www.travelers.com/about-travelers'>About Travelers</a>
        <a href='https://careers.travelers.com/'>Careers</a>
        <a href='https://investor.travelers.com/'>Investors</a>
        <a href='http://sustainability.travelers.com/'>Sustainability</a>
      </TdsGlobalFooterLinks>
      <TdsGlobalFooterLinks slot='links' heading='Connect'>
        <a href='https://www.travelers.com/contact-us'>Customer Support</a>
        <a href='https://www.travelers.com/online-service'>MyTravelers&reg;</a>
        <a href='https://www.travelers.com/foragents'>For Agents</a>
        <a href='https://agent.travelers.com/search'>Find an Agent</a>
      </TdsGlobalFooterLinks>
      <TdsGlobalFooterLinks slot='links' heading='Legal &amp; Compliance'>
        <a href='https://www.travelers.com/w3c/legal'>Terms of Service</a>
        <a href='https://www.travelers.com/privacy-statements/index.aspx'>Privacy &amp; Security</a>
        <a href='https://www.travelers.com/about-travelers/accessibility'>Accessibility</a>
        <a href='https://www.travelers.com/w3c/legal/Producer_Compensation_Disclosure.html'>
          Producer Compensation Disclosure
        </a>
      </TdsGlobalFooterLinks>
    </TdsGlobalFooter>
  )
}


export { Footer }
